import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { CustomCheckBox } from 'components/CommonComponents/GroupsTree/style'
import useLocaleText from 'components/useLocaleText'
import LocaleText from 'components/LocaleText'
import { KPIItem } from '../constants'
import {
  ModalTitle,
  ModalSubtitle,
  StyledInput,
  KpiListContainer,
  KpiItemRow,
  KpiLabel,
  AddKpiButton,
  AddKpiContainer,
  ButtonGroup,
  SmallButton,
} from '../styles'

interface KPIsStepProps {
  kpiItems: KPIItem[]
  setKpiItems: React.Dispatch<React.SetStateAction<KPIItem[]>>
  newKpiValue: string
  setNewKpiValue: (value: string) => void
  isAddingKpi: boolean
  setIsAddingKpi: (value: boolean) => void
}

export const KPIsStep: React.FC<KPIsStepProps> = ({
  kpiItems,
  setKpiItems,
  newKpiValue,
  setNewKpiValue,
  isAddingKpi,
  setIsAddingKpi,
}) => {
  const theme = useSelector((state: RootState) => state.general.theme)

  const kpis_popup_title = useLocaleText('kpis_popup_title', true)
  const kpis_popup_desc = useLocaleText('kpis_popup_desc', true)
  const t_add_your_kpi = useLocaleText('add_your_kpi', true)
  const t_cancel = useLocaleText('cancel', true)
  const t_add = useLocaleText('add', true)

  const handleKpiToggle = (kpiId: string) => {
    setKpiItems((prev) => prev.map((kpi) => (kpi.id === kpiId ? { ...kpi, isChecked: !kpi.isChecked } : kpi)))
  }

  const handleAddKpi = () => {
    if (newKpiValue.trim()) {
      const newKpi: KPIItem = {
        id: `custom-${Date.now()}`,
        label: newKpiValue.trim(),
        isChecked: true,
      }
      setKpiItems((prev) => [...prev, newKpi])
      setNewKpiValue('')
      setIsAddingKpi(false)
    }
  }

  return (
    <>
      <ModalTitle>{kpis_popup_title}</ModalTitle>
      <ModalSubtitle>{kpis_popup_desc}</ModalSubtitle>

      <KpiListContainer>
        {kpiItems.map((kpi) => (
          <KpiItemRow key={kpi.id}>
            <CustomCheckBox
              color={theme?.elementsColor}
              isChecked={kpi.isChecked}
              onChange={() => handleKpiToggle(kpi.id)}
              id={`kpi-checkbox-${kpi.id}`}
              name={`kpi-checkbox-${kpi.label}`}
            />
            <KpiLabel>
              <LocaleText text={kpi.label} isLocalUse={true} />
            </KpiLabel>
          </KpiItemRow>
        ))}

        {isAddingKpi ? (
          <AddKpiContainer>
            <StyledInput
              placeholder="Enter your KPI name"
              value={newKpiValue}
              onChange={(e: any) => setNewKpiValue(e.target.value)}
              onKeyPress={(e: any) => {
                if (e.key === 'Enter') {
                  handleAddKpi()
                }
              }}
              autoFocus
            />
            <ButtonGroup>
              <SmallButton onClick={handleAddKpi} disabled={!newKpiValue.trim()}>
                {t_add}
              </SmallButton>
              <SmallButton
                onClick={() => {
                  setIsAddingKpi(false)
                  setNewKpiValue('')
                }}
                variant="secondary"
              >
                {t_cancel}
              </SmallButton>
            </ButtonGroup>
          </AddKpiContainer>
        ) : (
          <AddKpiButton onClick={() => setIsAddingKpi(true)}>+ {t_add_your_kpi}</AddKpiButton>
        )}
      </KpiListContainer>
    </>
  )
}
